import styled from 'styled-components';

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ height }) => (height ? height : '43vh')};
`;

export const TitleContainer = styled.div`
  padding: 30px;
  font-family: 'McKinsey Sans', 'McKinsey Sans Regular', 'Helvetica Neue', Calibri, sans-serif;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  white-space: pre-line;
  line-height: 28px;
`;
